// extracted by mini-css-extract-plugin
export default {"wrap":"cvqDU","title":"WYRzV","image":"U2UVb","description":"opSBm","menu":"I8Ii3"};